import React, { useState } from 'react';
import { Create as CreateIcon, Close as CloseIcon } from '@mui/icons-material';
import { TableCell, TableRow } from '@mui/material';

import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';

import { formatHours } from '@/main/services/utilsDate';
import * as S from './styles';
import * as SP from '../styles';

import { BusinessHourResponse } from '@/main/models/response';
import { IPeriodBusinessInfoState } from '../businessHoursModal/businessHoursModal';
import { getIdCultureUser } from '@/main/services/utilsUser';
import { getTranslateByKey } from '@/main/services/utils';
import SecondaryButton from '../button/secondaryButton';

interface IBusinessHoursGridProps {
  rowHeaders: (string | React.JSX.Element)[];
  dataPeriodBusiness: BusinessHourResponse[];
  handleEditBusinessHoursInfo: (businessHour: IPeriodBusinessInfoState) => void;
  handleDeleteBusinessHourInfo: (id: string) => void;
  openModal: (nameProp: 'businessHours') => void;
}

function BusinessHoursGrid({
  rowHeaders,
  dataPeriodBusiness,
  handleEditBusinessHoursInfo,
  handleDeleteBusinessHourInfo,
  openModal
}: IBusinessHoursGridProps) {


  return (
    <S.Container>
      <SP.HeaderSection>
        <SP.HeaderText>
          {getTranslateByKey('information.periodOfBusinessHours')}
        </SP.HeaderText>
        <SecondaryButton
          id="id-register-btn-addBusinessHours"
          style={{ padding: '.2rem .8rem', margin: '.1rem 0 0 .8rem' }}
          onClick={() => openModal('businessHours')}>
          {getTranslateByKey('information.add')}
          {` ${getTranslateByKey('information.hour').toLowerCase()}`}
        </SecondaryButton>
      </SP.HeaderSection>
      {dataPeriodBusiness.length > 0 && (
        <BoxGrid rowHeaders={rowHeaders}>
          {dataPeriodBusiness.map(periodBusiness => (
            <TableRow key={periodBusiness.id}>
              <TableCell width="15%">
                {formatHours(periodBusiness.initialHour, getIdCultureUser())}
              </TableCell>
              <TableCell width="15%">
                {formatHours(periodBusiness.finalHour, getIdCultureUser())}
              </TableCell>
              <TableCell width="60%">{periodBusiness.description}</TableCell>
              <TableCell width="10%">
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <S.TextValue cursor="pointer">
                    <CreateIcon
                      onClick={() => handleEditBusinessHoursInfo(periodBusiness)}
                      id="id-register-icon-editBusinessHours"
                      color='primary'
                    />
                  </S.TextValue>
                  <S.TextValue cursor="pointer">
                    <CloseIcon
                      onClick={() =>
                        handleDeleteBusinessHourInfo(periodBusiness.id)
                      }
                      id="id-register-icon-deleteBusinessHour"
                      color='primary'
                    />
                  </S.TextValue>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </BoxGrid>
      )}
    </S.Container>
  );
}

export default BusinessHoursGrid;
